import axios from 'axios';

import lstModules from 'common/json/lstModules.json';

const httpURL = lstModules['main'].url + ':' + lstModules['main'].port;
const httpURLCommon = lstModules['main'].url + ':' + lstModules['main'].port;
var tokenid = localStorage.getItem("tokenid");


export const getStaffDtlsListSvc = (callback) => {
    // console.log("getStaffDtlsListSvc called");
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/panel/staff_dtls/list',
        method: "POST",
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('response in getStaffDtlsListSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstStaffDtls = response.data.lstStaffDtls;
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}


export const getClsSecListSvc = (callback) => {
    // console.log("getClsSecListSvc called");
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/tt/v1/tt/cls/syb/list',
        method: "POST",
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('response in getClsSecListSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstClsSec = response.data.lstClsSyb;
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}

export const getRoleListSvc = (callback) => {
    // console.log("getRoleListSvc called");
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/mst/roles/list',
        method: "POST",
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('response in getRoleListSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstRole = response.data.lstRole;
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}



export const saveStaffDtlsSvc = (staffDtlsObj, imgFile, callback) => {
    // console.log("saveStaffDtlsSvc called, staffDtlsObj", staffDtlsObj);
    const formData = new FormData();
    formData.append("staffDtlsObj", JSON.stringify(staffDtlsObj));
    formData.append("staffImg", imgFile);
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/panel/staff_dtls/save',
        method: "POST",
        headers: { 'tokenid': tokenid },
        data: formData,
        withCredentials: true,
    }).then((response) => {
        // console.log('response in saveStaffDtlsSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}

export function getClassListSvc(callBack) {
    axios(
        {
            url: httpURLCommon + "/sms/mst/cls/list",
            method: "POST",
            params: {},
            headers: { 'tokenid': tokenid },
            withCredentials: true
        }
    ).then((Response) => {
        var ourData = Response.data
        callBack(ourData)
    }).catch((error) => {
        callBack(error)
    });
}
export function getClassSectionListSvc(pClassId, callBack, pSectionId) {
    axios(
        {
            url: httpURL + "/sms/cls/sec/list",
            method: "POST",
            params: { classId: pClassId, screenId: 8 },
            headers: { 'tokenid': tokenid },
            withCredentials: true
        }
    ).then((Response) => {
        var ourData = Response.data
        callBack(ourData, pSectionId)
    }).catch((error) => {
        callBack(error)
    });
}
export function getSectionSubjectListSvc(pUserId, pSectionId, callBack) {
    axios(
        {
            url: httpURL + "/sms/system/staff/section_subject/list",
            method: "POST",
            params: { userId: pUserId, sectionId: pSectionId },
            headers: { 'tokenid': tokenid },
            withCredentials: true
        }
    ).then((Response) => {
        var ourData = Response.data
        callBack(ourData)
    }).catch((error) => {
        callBack(error)
    });
}
export function saveClassSectionSvc(pUserId, pClassId, pSectionId, pLstSubjectId, cbSaveClassSection) {
    // console.log("saveClassSectionSvc called, pUserId", pUserId, ", pLstSubjectId", pLstSubjectId);
    var formData = new FormData();
    formData.append("userId", pUserId)
    formData.append("clsId", pClassId)
    formData.append("sectionId", pSectionId)
    formData.append("lstSubjectId", JSON.stringify(pLstSubjectId))
    axios({
        url: httpURL + "/sms/system/staff/section_subject/save",
        method: "POST",
        data: formData,
        headers: { 'tokenid': tokenid },
        withCredentials: true
    }).then((response) => {
        var data = response.data
        cbSaveClassSection(data, pClassId, pSectionId)
    }).catch((error) => {
        // console.log("Error Occured") 
    });
}

export function getStaffClassSectionListSvc(pUserId, callBack) {
    axios(
        {
            url: httpURL + "/sms/system/staff/cls_section/list",
            method: "POST",
            params: { userId: pUserId },
            headers: { 'tokenid': tokenid },
            withCredentials: true
        }
    ).then((Response) => {
        var ourData = Response.data
        callBack(ourData)
    }).catch((error) => {
        callBack(error)
    });
}
export function deleteStaffSectionSvc(pUserId, pSectionId, callBack) {
    axios(
        {
            url: httpURL + "/sms/system/staff/cls_section/delete",
            method: 'POST',
            params: { userId: pUserId, sectionId: pSectionId },
            headers: { 'tokenid': tokenid },
            withCredentials: true
        }
    ).then(
        (Response) => {
            var data = Response.data;
            callBack(data);
        }
    ).catch((error) => {
        console.error(error)
    });
}